import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TokenService } from './token.service';
@Injectable({ providedIn: 'root' })
export class RoleGuard {

  constructor(
    private tokenService: TokenService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.tokenService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    const allowedRoles: string[] = route.data['roles'];
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    const userRoles = this.tokenService.getRoles();

    const allowed = userRoles.some(r => allowedRoles.includes(r));
    if (!allowed) {
      this.router.navigate(['/notfound']);
      return false;
    }

    return true;
  }
}